import React from "react"
import GlobalStyles from "@mui/material/GlobalStyles"
import {RESPONSIVE_PAGE_ATTRIBUTE, FOOTER_MFE_ID} from "./config/constants"

export const globalStyle = (
    <GlobalStyles
        styles={`
            #skip-namespace body{
                margin: 0;
            }

            #skip-namespace [dir="rtl"] #platform_modernisation_footer#platform_modernisation_footer{
                /* Override MVC */
                min-width: 100%;
            }
            
            #skip-namespace html[${RESPONSIVE_PAGE_ATTRIBUTE}="true"] #${FOOTER_MFE_ID} .footer-device-switcher {
                display: none !important;
            }

            #skip-namespace #${FOOTER_MFE_ID} {
                color: #000;
                font-size: 16px; 

                ul, ul li {
                    list-style: none; 
                }

                img, a img {
                    display: inline; 
                }

                h2 { 
                    /* Override MVC */
                    background: none;
                    padding: 0;
                    transition: unset;
                    text-indent: 0;
                    text-transform: none;
                    border-left: 0;
                    border-right: 0;
                }
            }
        `}
    />
)

/* istanbul ignore file */
